<template>
  <div class="box">
    <div class="container" :class="noShowBg?'showbg':''">
      <div class="content" :class="noShowBg?'show-content':''">
        <div class="arow" @click="back()"><img class="arow-img" src="../../assets/sportsLogo/back.png" alt=""></div>
        <div class="middle">
          <div class="event">
            <div class="event-cont" v-for="(item,index) in program" :key="index" @click="goEvent(item)">
              <a-avatar :size="55" :src="'https://static.daoba.com/sportsLogo/'+ item.id + '.png'" :style="{ backgroundColor: '#ffffff00'}">
                    <div class="font-css" style="font-size:17px;padding:0;border: 3px solid white;">
                      {{item.name.substring(0,1)}}
                    </div>
                    </a-avatar>
              <div class="event-name">{{item.name}}</div>
            </div>
          </div>
        </div>
        <div class="arow" @click="next()"><img class="arow-img" src="../../assets/sportsLogo/next.png" alt=""></div>
        <div class="slick">
            <div class="dot" v-for="(item,i ) in 3" :key="i" @click="handle(i)" :class="i+1==index?'dot-active':''"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ProgramSwiper',
  props:['noShowBg'],
  components: {},
  mounted () {
    this.loadData()
  },
  data () {
    return {
      all: [],
      program: [],
      index: 1,
    }
  },
  computed: {},
  methods: {
    handle (index) { 
      this.index = index+1
      this.handleIndex()
    },
    goEvent (item) {
      window.open('/ProgramMatch?programId=' + item.id)
    },
    back () {
      if (this.all.length !== 1) {
        if (this.index <= this.all.length && this.index !== 1) {
          this.index--
          this.handleIndex()
        }
      }
    },
    next () {
      if (this.all.length !== 1) {
        if (this.index < this.all.length) {
          this.index++
          this.handleIndex()
        }
      }
    },
    handleIndex () {
      this.program = this.all[this.index - 1]
    },
    loadData () {
      this.$api.match.getAllProgram().then(res => {
        if (res.status === 0) {
          // 数组切割，动态切换数组索引
          let newArr = []
          let arrLength = res.data.length
          let num = 10 // 每页显示 10 条
          let index = 0
          for (let i = 0; i < arrLength; i++) {
            if (i % num === 0 && i !== 0) { // 可以被 10 整除
              newArr.push(res.data.slice(index, i))
              index = i
            }
            if ((i + 1) === arrLength) {
              newArr.push(res.data.slice(index, (i + 1)))
            }
          }
          this.all = newArr
          this.handleIndex()
        }
      }).catch(err => {
        console.log(err)
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.box{
  width: 100%;
  position: relative;
  top:-60px;
}
.container{
  width: 100%;
  height: 320px;
  background-image: url('../../assets/weapon/playertopbg.jpg');
  background-repeat: no-repeat;
  background-size: cover;
  display: flex;
  justify-content: center;
  align-items: center;
}
.showbg{
    background-image: none; 
    background-color: #000;
    opacity: 0.8;
    height: 200px;
}
.content{
  width: 70%;
  height: 80%;
  margin: 0 auto;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding-top: 70px;
}
.show-content{
    padding-top: 0;
}
.arow{
  width: 50px;
  height: 50px;
}
.arow-img{
  width: 100%;
  height: 100%;
}
.middle{
  width: 80%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content:flex-start ;
  align-items: center;
}
.title{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  color: #FFF;
}
.title-main{
  display: flex;
  flex-direction: column;
  justify-content:center ;
  align-items: center;
  margin: 0 10px 10px 10px;
}
.title-main-cn{
  font-size: 22px;
}
.title-main-En{
  font-size: 14px;
}
.event{
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  max-lines: 2;
  justify-content: space-between;
  align-items: center;
  overflow: hidden;
}
.event-cont{
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 50px;
  padding: 50px 0px;
}
.event-cont:hover{
    transform:scale(1.2);
    cursor: pointer;
    .event-name{
        font-weight: bold;
    }
   
}
.event-img{
  width: 55px;
  height: 55px;
}
.event-name{
  color: #FFF;
  font-size: 12px;
}
.font-css{
  width:45px;height:45px;font-weight:bold;line-height: 35px;border-radius:50%;color:white;
}
.event /deep/ .ant-avatar-string {
  line-height: 80px;
  transform: scale(1) translateX(-50%);
  opacity: 1 !important;
}
.slick{
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-70px);
    width: 140px;
    height: 40px;
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    .dot{
        display: inline-block;
        width: 30px;
        height: 3px;
        border-radius: 3px;
        text-align: center;
        line-height: 20px;
        background-color: #fff;
        cursor: pointer;
    }
    .dot-active{
        transform: scale(1.3);
        background-color: #b01f23;
        cursor: pointer;
    }
}
</style>



// WEBPACK FOOTER //
// src/daoba-match/views/layout/ProgramSwiper.vue